import "../styles/Modal.scss";
import React from "react";

interface ModalProps {
    isOpen: boolean;
    onClose: () => void;
    title?: string;
    children: React.ReactNode;
    width?: string;
}

const Modal: React.FC<ModalProps> = ({ isOpen, onClose, title, children, width = "400px" }) => {
    if (!isOpen) return null;

    const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
        if (e.target === e.currentTarget) onClose();
    };

    return (
        <div className="modal-overlay" onClick={handleOverlayClick}>
            <div className="modal" style={{ width }}>
                {title && <h2 className="modal-title">{title}</h2>}
                <div className="modal-body">{children}</div>
                <div className="modal-actions">
                    <button className="close-btn" onClick={onClose}>Close</button>
                </div>
            </div>
        </div>
    );
};

export default Modal;
